import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { verifyFundBusinessAccountStatus } from "store/entities/wallet/action";
import Maybe from "components/__new/common/Maybe";

const AccountFundingStatus = () => {
    const dispatch = useDispatch();
    const history = useHistory()
    const query = new URLSearchParams(useLocation()?.search)
    const reference = query.get('reference');
    const status = query.get('status');
    const pageCode = query.get('pageCode');

    useEffect(() => {
        if (query) {
            const params = {
                reference,
                status,
                pageCode,
            }
            dispatch(verifyFundBusinessAccountStatus(params));
        }

        if (status?.toLowerCase() === "success") {
            history.push('/dashboard')
        }
    }, [query, status, dispatch, history]);

  return (
    <>
        <Maybe condition={status?.toLowerCase() === "pending"}>
            <div className="flex justify-center items-center box">
                <div className="text-center">
                    <div className="font-bold text-2xl mb-5">Verifying account funding status</div>
                    <div>
                        <FontAwesomeIcon icon="circle-notch" spin className="text-4xl"/>
                    </div>
                </div>
            </div>
        </Maybe>
    </>
  )
}

export default AccountFundingStatus;